// React APIs
import React from 'react';

// 機能内部のAPIs
import { DocList } from './DocList';
import { DocDetail } from './DocDetail';
import { DocSearch } from './DocSearch';
import { DocHoc } from './DocHoc';
import { DocCreate } from './DocCreate';
import { DocCreateConfirm } from './DocCreateConfirm';
import { DocDetailComment } from './DocDetailComment';
import { DocDetailSupplierComment } from './DocDetailSupplierComment';

/**
 * 文書管理のコンポネート
 */
export function Doc() {

  const docs = DocHoc(DocList, DocDetail, DocSearch, DocCreate, DocCreateConfirm, DocDetailComment, DocDetailSupplierComment);

  return (
    <>
      { docs }
    </>
  );
}
